import { TContentDomain } from '@/types/Content.types';
import { Box, HStack, Image } from '@chakra-ui/react';
import { DOMAIN_LABEL } from './contentLabels';

// Compact row of selected-domain icon tiles (for the thumbnail/feed card overlay).
const DomainIconTiles = ({ domains, max = 4 }: { domains: TContentDomain[]; max?: number }) => (
  <HStack gap="6px">
    {domains.slice(0, max).map((domain) => (
      <Box key={domain} backgroundColor="background.lightPurple" padding="5px" borderRadius="8px">
        <Image src={`/img/png/icons/wellness-domains-purple/${domain}.png`} width="16px" height="16px" alt={DOMAIN_LABEL[domain]} />
      </Box>
    ))}
  </HStack>
);

export default DomainIconTiles;
